import { trackingAxios } from 'config/api/tracking'
import { WarehouseResponse } from 'users/domain/warehouse'
import { IWarehouseRepository } from 'users/domain/IWarehouseRepository'

export class AxiosWarehouseRepository implements IWarehouseRepository {
    constructor() {}

    async get(): Promise<WarehouseResponse> {
        const response = await trackingAxios.get<WarehouseResponse>(
            '/warehouse'
        )
        return response.data
    }
}
